import React, { useState } from 'react';
import {
    TextField,
    Grid,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Typography,
} from '@mui/material';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import Navbar from '../../../Navbar';
import { supabase } from '../../../supabaseClient'

const MaterialForm = ({ selectedSession, materials, setMaterials }) => {
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');

    const handleUrlChange = (e) => {
        setUrl(e.target.value);
    };

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };

    const deleteMaterial = async (materialId) => {
        try {
            const { data, error } = await supabase
                .from('materials')
                .delete()
                .eq('id', materialId);

            if (error) {
                throw new Error(error.message);
            }

            console.log('Material deleted successfully');
        } catch (error) {
            console.error('Error deleting material:', error);
        }
    };

    const addMaterial = async (materialData) => {
        try {
            const { data, error } = await supabase
                .from('materials')
                .insert(materialData);

            if (error) {
                throw new Error(error.message);
            }

            console.log('Material added successfully');
        } catch (error) {
            console.error('Error adding material:', error);
        }
    };

    const handleDeleteMaterial = (index, id) => {
        const updatedMaterials = [...materials];
        updatedMaterials.splice(index, 1);
        setMaterials(updatedMaterials);

        deleteMaterial(id)
    };

    const handleMaterialSubmit = (e) => {
        try {
            e.preventDefault();
            const newMaterial = {
                title: title,
                url: url,
                session: selectedSession.id
            };
            
            addMaterial(newMaterial)
    
            setMaterials([...materials, newMaterial]);
            setUrl('');
            setTitle('');
        } catch (error) {
            console.log(error)
        }
       

    };

    return (
        <>
            <MaterialList materials={materials} handleDeleteMaterial={handleDeleteMaterial} />

            <form onSubmit={handleMaterialSubmit}>
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        <TextField
                            label="Título"
                            value={title}
                            onChange={handleTitleChange}
                            required
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            label="URL"
                            value={url}
                            onChange={handleUrlChange}
                            required
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={12}>
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Agregar Material
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    );
};

const MaterialList = ({ materials, handleDeleteMaterial }) => {
    return (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {materials && materials.map((material, index) => (
                <ListItem key={index}>
                    <ListItemIcon>
                        <InsertDriveFile />
                    </ListItemIcon>
                    <ListItemText primary={material.title} secondary={material.url} />
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleDeleteMaterial(index, material.id)}
                    >
                        Borrar
                    </Button>
                </ListItem>
            ))}
        </List>
    );
};
export default MaterialForm;
